[
{
  "link": "/kuume",
  "name": "Kuume"
},
{
  "link": "/vesirokko",
  "name": "Vesirokko"
},
{
  "link": "/keuhkokuume",
  "name": "Keuhkokuume"
},
{
  "link": "/korkea-verenpaine",
  "name": "Korkea verenpaine"
},
{
  "link": "/oire/diabetes",
  "name": "Diabetes"
},
{
  "link": "/kylma",
  "name": "Kylma"
},
{
  "link": "/lapsen-nuha",
  "name": "Lapsen nuha"
},
{
  "link": "/lapsen-yska",
  "name": "Lapsen yska"
},
{
  "link": "/pahoinvointi",
  "name": "Pahoinvointi"
},
{
  "link": "/hinkuyska",
  "name": "Hinkuyskä"
},
{
  "link": "/ripuli",
  "name": "Ripuli"
},
{
  "link": "/narastys",
  "name": "Närästys"
},
{
  "link": "/kipu",
  "name": "Kipu"
},
{
  "link": "/selkakipu",
  "name": "Selkäkipu"
},
{
  "link": "/paansarky",
  "name": "Päänsärky"
},
{
  "link": "/vatsan-kipu",
  "name": "Vatsakipu"
},
{
  "link": "/kipea-kurkku",
  "name": "Kipeä kurkku"
},
{
  "link": "/ihotulehdus",
  "name": "Ihotulehdus"
},
{
  "link": "/rokotus",
  "name": "Rokotus"
},
{
  "link": "/oire/anemia",
  "name": "Anemia"
},
{
  "link": "/huimaus",
  "name": "Huimaus"
},
{
  "link": "/virtsan-ongelmat",
  "name": "Virtsaongelmat"
},
{
  "link": "/flunssa",
  "name": "Flunssa"
},
{
  "link": "/oire/allergia",
  "name": "Allergia"
},
{
  "link": "/sidekalvontulehdus",
  "name": "Sidekalvontulehdus"
}]